module.exports = __webpack_public_path__ + "media/images/riders/small/MARCELLO_GUTIERREZ-e4879a7c4baf5ae8e5816bb17dc641bb.png";